// User Management Actions
export const getAdminUsers = (payload) => ({ 
  payload,
  type: 'GET_ADMIN_USERS' 
})

export const getAdminUserStats = () => ({ 
  type: 'GET_ADMIN_USER_STATS' 
})

export const exportAdminUsers = (payload) => ({ 
  payload,
  type: 'EXPORT_ADMIN_USERS' 
})

export const updateAdminUser = (payload) => ({ 
  payload,
  type: 'UPDATE_ADMIN_USER'
})

export const createAdminUser = (payload) => ({ 
  payload,
  type: 'CREATE_ADMIN_USER'
})

export const impersonateUser = (payload) => ({ 
  payload,
  type: 'IMPERSONATE_USER'
})

export const exitImpersonation = (payload) => ({ 
  payload,
  type: 'EXIT_IMPERSONATION'
})

export const deleteAdminUser = (payload) => ({
  payload,
  type: 'DELETE_ADMIN_USER'
})

export const getDeletedUsers = (payload) => ({
  payload,
  type: 'GET_DELETED_USERS'
})

export const restoreUser = (payload) => ({
  payload,
  type: 'RESTORE_USER'
})

// Workspace Management Actions
export const getAvailableWorkspaces = () => ({
  type: 'GET_AVAILABLE_WORKSPACES'
})

export const setAvailableWorkspaces = (payload) => ({
  payload,
  type: 'SET_AVAILABLE_WORKSPACES'
})

export const getWorkspacePlans = () => ({
  type: 'GET_WORKSPACE_PLANS'
})

// Workspace Management Actions
export const getAdminWorkspaces = (payload) => ({ 
  payload,
  type: 'GET_ADMIN_WORKSPACES' 
})

export const getWorkspaceStats = () => ({ 
  type: 'GET_WORKSPACE_STATS' 
})

export const exportAdminWorkspaces = (payload) => ({ 
  payload,
  type: 'EXPORT_ADMIN_WORKSPACES' 
})

export const getWorkspaceById = (payload) => ({
  payload,
  type: 'GET_WORKSPACE_BY_ID'
})

export const updateAdminWorkspace = (payload) => ({ 
  payload,
  type: 'UPDATE_ADMIN_WORKSPACE'
})

export const deleteAdminWorkspace = (payload) => ({
  payload,
  type: 'DELETE_ADMIN_WORKSPACE'
})

export const getDeletedWorkspaces = (payload) => ({
  payload,
  type: 'GET_DELETED_WORKSPACES'
})

export const restoreWorkspace = (payload) => ({
  payload,
  type: 'RESTORE_WORKSPACE'
})

// Workspace Branding Actions
export const getWorkspaceBranding = (payload) => ({ 
  payload,
  type: 'GET_WORKSPACE_BRANDING'
})

export const updateWorkspaceBranding = (payload) => ({ 
  payload,
  type: 'UPDATE_WORKSPACE_BRANDING'
})

export const uploadBrandingAsset = (payload) => ({ 
  payload,
  type: 'UPLOAD_BRANDING_ASSET'
})

export const verifyCustomDomain = (payload) => ({ 
  payload,
  type: 'VERIFY_CUSTOM_DOMAIN'
})

export const getDomainInstructions = (payload) => ({ 
  payload,
  type: 'GET_DOMAIN_INSTRUCTIONS'
})

export const generateVerificationToken = (payload) => ({ 
  payload,
  type: 'GENERATE_VERIFICATION_TOKEN'
})

// SSL Certificate Actions
export const requestSSLCertificate = (payload) => ({
  payload,
  type: 'REQUEST_SSL_CERTIFICATE'
})

export const verifySSLCertificate = (payload) => ({
  payload,
  type: 'VERIFY_SSL_CERTIFICATE'
})

export const checkSSLStatus = (payload) => ({ 
  payload,
  type: 'CHECK_SSL_STATUS'
})

// Billing Management Actions
export const getAdminSubscriptions = (payload) => ({ 
  payload,
  type: 'GET_ADMIN_SUBSCRIPTIONS' 
})

export const getSubscriptionStats = () => ({ 
  type: 'GET_SUBSCRIPTION_STATS' 
})

export const getSubscriptionById = (payload) => ({ 
  payload,
  type: 'GET_SUBSCRIPTION_BY_ID'
})

export const updateSubscription = (payload) => ({ 
  payload,
  type: 'UPDATE_SUBSCRIPTION'
})

export const cancelSubscription = (payload) => ({ 
  payload,
  type: 'CANCEL_SUBSCRIPTION'
})

export const reactivateSubscription = (payload) => ({ 
  payload,
  type: 'REACTIVATE_SUBSCRIPTION'
})

export const applyCredit = (payload) => ({ 
  payload,
  type: 'APPLY_CREDIT'
})

export const getAllSubscriptionsForExport = (payload) => ({
  payload,
  type: 'GET_ALL_SUBSCRIPTIONS_FOR_EXPORT'
})

export const bulkCancelSubscriptions = (payload) => ({
  payload,
  type: 'BULK_CANCEL_SUBSCRIPTIONS'
})

export const bulkReactivateSubscriptions = (payload) => ({
  payload,
  type: 'BULK_REACTIVATE_SUBSCRIPTIONS'
})

export const bulkApplyCredits = (payload) => ({
  payload,
  type: 'BULK_APPLY_CREDITS'
})

export const getPayments = (payload) => ({ 
  payload,
  type: 'GET_PAYMENTS_ADMIN'
})

export const processRefund = (payload) => ({ 
  payload,
  type: 'PROCESS_REFUND'
})

export const getRevenueAnalytics = (payload) => ({ 
  payload,
  type: 'GET_REVENUE_ANALYTICS'
})

export const getMRRAnalytics = () => ({ 
  type: 'GET_MRR_ANALYTICS'
})

export const getPlansOverview = () => ({
  type: 'GET_PLANS_OVERVIEW'
})

export const getBillingOverview = (payload) => ({
  payload,
  type: 'GET_BILLING_OVERVIEW'
})

export const getAgencyPlanPerformance = () => ({
  type: 'GET_AGENCY_PLAN_PERFORMANCE'
})

export const getUserAccessType = () => ({
  type: 'GET_USER_ACCESS_TYPE'
})

// Plan Management Actions
export const getAdminPlans = (payload) => ({ 
  payload,
  type: 'GET_ADMIN_PLANS'
})

export const updatePlan = (payload) => ({ 
  payload,
  type: 'UPDATE_PLAN'
})

export const togglePlanStatus = (payload) => ({ 
  payload,
  type: 'TOGGLE_PLAN_STATUS'
})

// Subscription Details Actions
export const getSubscriptionPayments = (payload) => ({ 
  payload,
  type: 'GET_SUBSCRIPTION_PAYMENTS'
})

export const getSubscriptionActivity = (payload) => ({ 
  payload,
  type: 'GET_SUBSCRIPTION_ACTIVITY'
})

export const getSubscriptionUsageHistory = (payload) => ({ 
  payload,
  type: 'GET_SUBSCRIPTION_USAGE_HISTORY'
})

export const applySubscriptionCredit = (payload) => ({ 
  payload,
  type: 'APPLY_SUBSCRIPTION_CREDIT'
})

// Agent Management Actions
export const getAdminAgents = (payload) => ({ 
  payload,
  type: 'GET_ADMIN_AGENTS' 
})

export const getAgentStats = () => ({ 
  type: 'GET_AGENT_STATS' 
})

export const exportAdminAgents = (payload) => ({ 
  payload,
  type: 'EXPORT_ADMIN_AGENTS' 
})

export const getAgentById = (payload) => ({ 
  payload,
  type: 'GET_AGENT_BY_ID'
})

export const activateAgent = (payload) => ({ 
  payload,
  type: 'ACTIVATE_AGENT'
})

export const deactivateAgent = (payload) => ({ 
  payload,
  type: 'DEACTIVATE_AGENT'
})

export const bulkUpdateAgentStatus = (payload) => ({ 
  payload,
  type: 'BULK_UPDATE_AGENT_STATUS'
})

export const startAgent = (payload) => ({ 
  payload,
  type: 'START_AGENT'
})

export const stopAgent = (payload) => ({ 
  payload,
  type: 'STOP_AGENT'
})

export const restartAgent = (payload) => ({ 
  payload,
  type: 'RESTART_AGENT'
})

export const getAgentLogs = (payload) => ({ 
  payload,
  type: 'GET_AGENT_LOGS'
})

export const getAgentCalls = (payload) => ({ 
  payload,
  type: 'GET_AGENT_CALLS'
})

export const bulkAgentAction = (payload) => ({ 
  payload,
  type: 'BULK_AGENT_ACTION'
})

export const getPerformanceMetrics = (payload) => ({ 
  payload,
  type: 'GET_PERFORMANCE_METRICS'
})

export const getCostAnalytics = (payload) => ({ 
  payload,
  type: 'GET_COST_ANALYTICS'
})

// System Monitoring Actions
export const getSystemHealth = () => ({ 
  type: 'GET_SYSTEM_HEALTH' 
})

export const getSystemServices = () => ({ 
  type: 'GET_SYSTEM_SERVICES' 
})

export const getSystemMetrics = (payload) => ({ 
  payload,
  type: 'GET_SYSTEM_METRICS'
})

export const getSystemAlerts = (payload) => ({ 
  payload,
  type: 'GET_SYSTEM_ALERTS'
})

export const getSystemPerformance = () => ({ 
  type: 'GET_SYSTEM_PERFORMANCE' 
})

export const getAgentPerformance = (payload) => ({
  payload,
  type: 'GET_AGENT_PERFORMANCE'
});

// Dashboard Actions
export const getAdminDashboard = () => ({ 
  type: 'GET_ADMIN_DASHBOARD' 
})

export const getAgentHealthOnly = () => ({
  type: 'GET_AGENT_HEALTH_ONLY'
})

// Set Actions for Reducer
export const setAdminUsers = (payload) => ({ 
  payload,
  type: 'SET_ADMIN_USERS'
})

export const setAdminUserStats = (payload) => ({
  payload,
  type: 'SET_ADMIN_USER_STATS'
})

export const setDeletedUsers = (payload) => ({
  payload,
  type: 'SET_DELETED_USERS'
})

export const setAdminWorkspaces = (payload) => ({ 
  payload,
  type: 'SET_ADMIN_WORKSPACES'
})

export const setWorkspaceStats = (payload) => ({ 
  payload,
  type: 'SET_WORKSPACE_STATS'
})

export const setSelectedWorkspaceDetails = (payload) => ({
  payload,
  type: 'SET_SELECTED_WORKSPACE_DETAILS'
})

export const getWorkspaceActivity = (payload) => ({
  payload,
  type: 'GET_WORKSPACE_ACTIVITY'
})

export const setWorkspaceActivity = (payload) => ({
  payload,
  type: 'SET_WORKSPACE_ACTIVITY'
})

// Workspace Detail Sidebar Actions
export const getWorkspaceMembers = (payload) => ({
  payload,
  type: 'GET_WORKSPACE_MEMBERS'
})

export const setWorkspaceMembers = (payload) => ({
  payload,
  type: 'SET_WORKSPACE_MEMBERS'
})

export const getWorkspaceContacts = (payload) => ({
  payload,
  type: 'GET_WORKSPACE_CONTACTS'
})

export const setWorkspaceContacts = (payload) => ({
  payload,
  type: 'SET_WORKSPACE_CONTACTS'
})

export const getWorkspaceDeals = (payload) => ({
  payload,
  type: 'GET_WORKSPACE_DEALS'
})

export const setWorkspaceDeals = (payload) => ({
  payload,
  type: 'SET_WORKSPACE_DEALS'
})

export const getWorkspaceAgents = (payload) => ({
  payload,
  type: 'GET_WORKSPACE_AGENTS'
})

export const setWorkspaceAgents = (payload) => ({
  payload,
  type: 'SET_WORKSPACE_AGENTS'
})

export const getOwnerWorkspaces = (payload) => ({
  payload,
  type: 'GET_OWNER_WORKSPACES'
})

export const setOwnerWorkspaces = (payload) => ({
  payload,
  type: 'SET_OWNER_WORKSPACES'
})

export const getAccountAgents = (payload) => ({
  payload,
  type: 'GET_ACCOUNT_AGENTS'
})

export const setAccountAgents = (payload) => ({
  payload,
  type: 'SET_ACCOUNT_AGENTS'
})

export const getWorkspacePaymentHistory = (payload) => ({
  payload,
  type: 'GET_WORKSPACE_PAYMENT_HISTORY'
})

export const setWorkspacePaymentHistory = (payload) => ({
  payload,
  type: 'SET_WORKSPACE_PAYMENT_HISTORY'
})

export const setWorkspaceBranding = (payload) => ({
  payload,
  type: 'SET_WORKSPACE_BRANDING'
})

export const setDomainInstructions = (payload) => ({
  payload,
  type: 'SET_DOMAIN_INSTRUCTIONS'
})

export const setAdminSubscriptions = (payload) => ({ 
  payload,
  type: 'SET_ADMIN_SUBSCRIPTIONS'
})

export const setSubscriptionStats = (payload) => ({ 
  payload,
  type: 'SET_SUBSCRIPTION_STATS'
})

export const setSelectedSubscription = (payload) => ({ 
  payload,
  type: 'SET_SELECTED_SUBSCRIPTION'
})

export const setPayments = (payload) => ({ 
  payload,
  type: 'SET_PAYMENTS'
})

export const setRevenueAnalytics = (payload) => ({ 
  payload,
  type: 'SET_REVENUE_ANALYTICS'
})

export const setMRRAnalytics = (payload) => ({ 
  payload,
  type: 'SET_MRR_ANALYTICS'
})

export const setPlansOverview = (payload) => ({ 
  payload,
  type: 'SET_PLANS_OVERVIEW'
})

export const setAdminPlans = (payload) => ({ 
  payload,
  type: 'SET_ADMIN_PLANS'
})

export const setAdminAgents = (payload) => ({ 
  payload,
  type: 'SET_ADMIN_AGENTS'
})

export const setAgentStats = (payload) => ({ 
  payload,
  type: 'SET_AGENT_STATS'
})

export const setSelectedAgent = (payload) => ({ 
  payload,
  type: 'SET_SELECTED_AGENT'
})

export const setAgentLogs = (payload) => ({ 
  payload,
  type: 'SET_AGENT_LOGS'
})

export const setAgentCalls = (payload) => ({ 
  payload,
  type: 'SET_AGENT_CALLS'
})

export const setPerformanceMetrics = (payload) => ({ 
  payload,
  type: 'SET_PERFORMANCE_METRICS'
})

export const setCostAnalytics = (payload) => ({ 
  payload,
  type: 'SET_COST_ANALYTICS'
})

export const setSystemHealth = (payload) => ({ 
  payload,
  type: 'SET_SYSTEM_HEALTH'
})

export const setSystemServices = (payload) => ({ 
  payload,
  type: 'SET_SYSTEM_SERVICES'
})

export const setSystemMetrics = (payload) => ({ 
  payload,
  type: 'SET_SYSTEM_METRICS'
})

export const setSystemAlerts = (payload) => ({ 
  payload,
  type: 'SET_SYSTEM_ALERTS'
})

export const setSystemPerformance = (payload) => ({ 
  payload,
  type: 'SET_SYSTEM_PERFORMANCE'
})

export const setAgentPerformance = (payload) => ({
  payload,
  type: 'SET_AGENT_PERFORMANCE'
});

export const setAdminDashboard = (payload) => ({ 
  payload,
  type: 'SET_ADMIN_DASHBOARD'
})

export const setAdminLoading = (payload) => ({ 
  payload,
  type: 'SET_ADMIN_LOADING'
})

// Analytics Actions
export const getAnalyticsData = (payload) => ({ 
  payload,
  type: 'GET_ANALYTICS_DATA'
})

export const setAnalyticsData = (payload) => ({ 
  payload,
  type: 'SET_ANALYTICS_DATA'
})

export const getCustomReport = (payload) => ({ 
  payload,
  type: 'GET_CUSTOM_REPORT'
})

export const getReports = () => ({ 
  type: 'GET_REPORTS'
})

export const setCustomReports = (payload) => ({ 
  payload,
  type: 'SET_CUSTOM_REPORTS'
})

export const exportReport = (payload) => ({ 
  payload,
  type: 'EXPORT_REPORT'
})

// Security & Compliance Actions  
export const getAuditLogs = (payload) => ({ 
  payload,
  type: 'GET_AUDIT_LOGS'
})

export const setAuditLogs = (payload) => ({ 
  payload,
  type: 'SET_AUDIT_LOGS'
})

// Credit Management Actions
export const addCredits = (payload) => ({
  payload,
  type: 'ADD_CREDITS'
})

export const getCreditHistory = (payload) => ({
  payload,
  type: 'GET_CREDIT_HISTORY'
})

export const setCreditHistory = (payload) => ({
  payload,
  type: 'SET_CREDIT_HISTORY'
})

export const getAllWorkspaces = () => ({
  type: 'GET_ALL_WORKSPACES'
})

export const setAllWorkspaces = (payload) => ({
  payload,
  type: 'SET_ALL_WORKSPACES'
})

export const getWorkspaceCredits = () => ({
  type: 'GET_WORKSPACE_CREDITS'
})

export const setWorkspaceCredits = (payload) => ({
  payload,
  type: 'SET_WORKSPACE_CREDITS'
})

export const getSecuritySettings = () => ({ 
  type: 'GET_SECURITY_SETTINGS'
})

export const setSecuritySettings = (payload) => ({ 
  payload,
  type: 'SET_SECURITY_SETTINGS'
})

export const updateSecuritySettings = (payload) => ({ 
  payload,
  type: 'UPDATE_SECURITY_SETTINGS'
})

// Security: API Keys and IP Whitelist
export const createApiKey = (payload) => ({ 
  payload,
  type: 'CREATE_API_KEY'
})

export const revokeApiKey = (payload) => ({ 
  payload,
  type: 'REVOKE_API_KEY'
})

export const addWhitelistIp = (payload) => ({ 
  payload,
  type: 'ADD_WHITELIST_IP'
})

export const removeWhitelistIp = (payload) => ({ 
  payload,
  type: 'REMOVE_WHITELIST_IP'
})

// Compliance Actions
export const getComplianceStatus = () => ({ 
  type: 'GET_COMPLIANCE_STATUS'
})

export const setComplianceStatus = (payload) => ({ 
  payload,
  type: 'SET_COMPLIANCE_STATUS'
})

export const updateGDPRCompliance = (payload) => ({ 
  payload,
  type: 'UPDATE_GDPR_COMPLIANCE'
})

export const updateDataRetention = (payload) => ({ 
  payload,
  type: 'UPDATE_DATA_RETENTION'
})

export const getDataRequests = () => ({ 
  type: 'GET_DATA_REQUESTS'
})

export const setDataRequests = (payload) => ({ 
  payload,
  type: 'SET_DATA_REQUESTS'
})

export const createDataRequest = (payload) => ({ 
  payload,
  type: 'CREATE_DATA_REQUEST'
})

export const processDataRequest = (payload) => ({ 
  payload,
  type: 'PROCESS_DATA_REQUEST'
})

export const generateComplianceReport = (payload) => ({ 
  payload,
  type: 'GENERATE_COMPLIANCE_REPORT'
})

// WebSocket Related Actions
export const addSystemAlert = (payload) => ({ 
  payload,
  type: 'ADD_SYSTEM_ALERT'
})

export const clearSystemAlerts = () => ({ 
  type: 'CLEAR_SYSTEM_ALERTS'
})

// Email Templates Actions
export const getEmailTemplates = (payload) => ({ 
  payload,
  type: 'GET_EMAIL_TEMPLATES' 
})

export const getTemplateStats = () => ({ 
  type: 'GET_TEMPLATE_STATS' 
})

export const createEmailTemplate = (payload) => ({ 
  payload,
  type: 'CREATE_EMAIL_TEMPLATE' 
})

export const updateEmailTemplate = (payload) => ({ 
  payload,
  type: 'UPDATE_EMAIL_TEMPLATE' 
})

export const deleteEmailTemplate = (payload) => ({ 
  payload,
  type: 'DELETE_EMAIL_TEMPLATE' 
})

export const activateTemplate = (payload) => ({ 
  payload,
  type: 'ACTIVATE_TEMPLATE' 
})

export const deactivateTemplate = (payload) => ({ 
  payload,
  type: 'DEACTIVATE_TEMPLATE' 
})

export const duplicateTemplate = (payload) => ({ 
  payload,
  type: 'DUPLICATE_TEMPLATE' 
})

export const setEmailTemplates = (payload) => ({ 
  payload,
  type: 'SET_EMAIL_TEMPLATES' 
})

export const setTemplateStats = (payload) => ({ 
  payload,
  type: 'SET_TEMPLATE_STATS' 
})

// Activity Log Actions
export const getActivityLogs = (payload) => ({ 
  payload,
  type: 'GET_ACTIVITY_LOGS' 
})

export const getActivityStats = () => ({ 
  type: 'GET_ACTIVITY_STATS' 
})

export const setActivityLogs = (payload) => ({ 
  payload,
  type: 'SET_ACTIVITY_LOGS' 
})

export const setActivityStats = (payload) => ({ 
  payload,
  type: 'SET_ACTIVITY_STATS' 
})

export const clearOldLogs = () => ({ 
  type: 'CLEAR_OLD_LOGS' 
})

export const archiveLogs = () => ({ 
  type: 'ARCHIVE_LOGS' 
})

// User-specific activity for Admin Users preview
export const getUserActivities = (payload) => ({
  payload,
  type: 'GET_USER_ACTIVITIES'
})

// User Detail Sidebar Actions
export const getUserWorkspaces = (payload) => ({
  payload,
  type: 'GET_USER_WORKSPACES'
})

export const setUserWorkspaces = (payload) => ({
  payload,
  type: 'SET_USER_WORKSPACES'
})

export const getUserBillingHistory = (payload) => ({
  payload,
  type: 'GET_USER_BILLING_HISTORY'
})

export const setUserBillingHistory = (payload) => ({
  payload,
  type: 'SET_USER_BILLING_HISTORY'
})

export const getUserSecurityLogs = (payload) => ({
  payload,
  type: 'GET_USER_SECURITY_LOGS'
})

export const setUserSecurityLogs = (payload) => ({
  payload,
  type: 'SET_USER_SECURITY_LOGS'
})

export const setUserActivities = (payload) => ({
  payload,
  type: 'SET_USER_ACTIVITIES'
})